/**
 * Catálogo do domínio `seguros` (T53, CAT-02).
 *
 * Origem: `src/shared/autorizacao/Seguro.ts`.
 */
import type { NomePapel, Papel } from "../catalogo/vocabulario";

export const PAPEIS_SEGUROS = {
  "seguros.admin": {
    dominio: "seguros",
    nivel: "admin",
    concessoes: [{ acoes: ["manage"], recurso: "SEGUROS" }],
  },
  "seguros.escrita": {
    dominio: "seguros",
    nivel: "escrita",
    concessoes: [{ acoes: ["create", "read", "delete", "edit"], recurso: "SEGUROS" }],
  },
  /** `Seguro.ts:15` concede a `site_manager`; o grupo SITE_MANAGER carrega este papel. */
  "seguros.leitura": {
    dominio: "seguros",
    nivel: "leitura",
    concessoes: [{ acoes: ["read"], recurso: "SEGUROS" }],
  },
} as const satisfies Partial<Record<NomePapel, Papel>>;
